module.exports = __webpack_public_path__ + "static/img/13.b843c93.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/13.png
// module id = r5/F
// module chunks = 0